import { useWallet } from '@solana/wallet-adapter-react';
import { WalletDisconnectButton, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import React, { useEffect } from 'react';
import * as R from 'ramda';
import { useHistory } from 'react-router-dom';
import { FlowConfig, issuanceFlow, flowConfigs } from '../config/flowConfig';

export interface ButtonProps {
  className?: string;
  buttonLabel?: string;
}

export default function WalletAdapterButton(props: ButtonProps): JSX.Element {
  const { wallet, connected } = useWallet();
  const { className, buttonLabel } = props;
  const history = useHistory();

  useEffect(() => {
    if (wallet || connected) {
      return;
    }

    // find the flow config for the current route or default to the issuance route
    const flowConfig: FlowConfig =
      R.find((config) => R.contains(history.location.pathname, config.routes), flowConfigs) || issuanceFlow;

    // navigate to the connect wallet route if specified
    if (flowConfig.connectWalletRoute && history.location.pathname !== flowConfig.connectWalletRoute) {
      history.push(flowConfig.connectWalletRoute);
    }
  }, [wallet, connected, history]);

  return (
    <>
      {!connected && <WalletMultiButton className={className}>{buttonLabel}</WalletMultiButton>}
      {wallet && connected && (
        <div className="wallet-connection-button">
          <WalletDisconnectButton />
        </div>
      )}
    </>
  );
}

WalletAdapterButton.defaultProps = {
  className: '',
  buttonLabel: '',
};
